export default __webpack_public_path__ + "static/media/illi5.4e1b5796.png";